<template>
  <div class="view">
    <h2 class="ui inverted header">Reset password</h2>
    <div>
      <sui-message icon="check circle" header="Success" positive>
        You will be redirected to the <router-link to="/user/login">Log in</router-link> page in <code>{{seconds}}</code> {{pluralize('second', seconds)}}.
      </sui-message>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccountRecoveryEnd',
    data() {
      return {
        seconds: 5,
      }
    },
    methods: {
      nextSecond() {
        setTimeout(() => {
          this.$nextTick(() => {
            this.seconds -= 1
            if (this.seconds) {
              this.nextSecond()
            } else {
              this.$router.push('/user/login')
            }
          })
        }, 1000)
      }
    },
    created() {
      this.nextSecond()
    }
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; }
</style>
